import BaseUtil from "../../../util/BaseUtil";
import UserTypeUtil from "../../../util/UserTypeUtil";

const type = `@@ActionType/UPDATE@${__filename}`;


const initState = {
    datePicker: {
        beginDate: null,
        endDate: null,
    },
    selectedUnitIds: [],
    selectedUserTypes: UserTypeUtil.getAllUserTypeCodes(),
    unitsMap: null, // 科室map
    chart: null, // 图表key
    loading: false, // 数据加载
    chartData: null, // 图表数据
    tableData: null, // 表格数据
    dataKeys: null, // 表格columns

    detailDrawerVisible: false, // 详情显隐
    detailDrawerData: null, // 详情数据
    detailDrawerLoading: false, // 详情加载
    clickedCell: {
        unitId: null, // 点击查看详情的科室
        option: null, // 点击查看详情的字典
        title: null, // 点击查看详情的标题
    },
    selectedHospitalIds: ["ALL"],
    selectedDistrictIds: ["ALL"],
    // 筛选
    filterDisplay: null,
    filterData: null,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
